module.exports = __webpack_public_path__ + "media/images/app/homepage/weddings/consultation-banner-mobile-ba3c002d22895e1ea7d90541914e83c0.webp";